module.exports = __webpack_public_path__ + "static/mr-press-23-a5df640cc2d31e9bf71faf76b6fdfe83.jpg";